<template>
	<v-app id="login-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<v-toolbar-title>
				<a href="/">
					<img src="/logo-wide.png" style="float: right;max-width: 100px;max-height: 40px;" />
				</a>
				<strong class="mr-1 font-weight-black">ورود به پنل کاربری</strong>
				&nbsp;
				<span class="warning--text">{{ longTitle }}</span>
			</v-toolbar-title>
		</v-app-bar>
		<v-container>
			<v-row align="center" justify="center">
				<v-col cols="10" md="6" xl="4">
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="!forgotPassword">
								<v-img class="white--text align-end" height="200px" src="/login-banner.jpg">
									<v-card-title style="background-color: #434343c7;padding: 10px;">
										نام کاربری و کلمه عبور خود را وارد کنید
									</v-card-title>
								</v-img>
								<v-form ref="formLogin" class="mx-2" lazy-validation @submit.prevent="handleLogin">
									<v-row>
										<v-col cols="12" class="mt-4">
											<v-text-field ref="username" class="left-input" v-model="user.username" label="نام کاربری" persistent-hint :hint="!isCloud ? 'مشتریان عزیز از کد ملی به عنوان نام کاربری استفاده کنید.' : ''" :error-messages="errorMessages" :rules="[() => user.username != '' || 'نام کاربری را وارد کنید']" focused />
										</v-col>
										<v-col cols="12">
											<v-text-field ref="password" class="left-input" v-model="user.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => !!user.password || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور" @click:append="show1 = !show1" />
										</v-col>
									</v-row>
									<v-row class="mx-0 ">
										<v-col cols="4" class="px-0">
											<v-text-field label="کد امنیتی" maxLength="4" v-model="loginCaptcha">
											</v-text-field>
										</v-col>
										<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
											<v-btn class="mr-1" color="secondary" small fab icon @click="refreshLoginCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
											<CaptchaImage ref="loginCaptcha" :codeType="['0']" style="direction: ltr;" />
										</v-col>
									</v-row>
									<div class="form-group">
										<div v-if="message" class="alert alert-danger" role="alert">
											{{ message }}
										</div>
									</div>
									<v-card-actions>
										<v-spacer />
										<v-btn ref="submit" color="secondary" dark :loading="loading" type="submit">
											ورود
										</v-btn>
										<v-spacer />
									</v-card-actions>
									<div class="text-center my-3">
										<div class="text-center">
											<v-btn class="mx-auto mb-0" text @click="forgotPassword = true">
												فراموشی کلمه عبور؟
											</v-btn>
										</div>
										<div>
											<v-btn class="mx-auto mb-2" text @click="goToRegister" v-if="showRegisterBtn">
												در سایت عضو نیستید؟ ثبت نام کنید
											</v-btn>
										</div>
									</div>
								</v-form>
							</div>
						</v-slide-x-transition>
					</v-card>
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="forgotPassword">
								<v-img class="white--text align-end" height="200px" :src="require('@/assets/docks.jpg')">
									<v-card-title style="background-color: #434343c7;padding: 10px;">نام کاربری جهت بازیابی کلمه عبور را
										وارد کنید</v-card-title>
								</v-img>
								<v-form ref="formForgot" class="mx-2" lazy-validation @submit.prevent="handleForgot">
									<v-row>
										<v-col cols="12" class="mt-4">
											<v-text-field ref="username" v-model="forgot.username" label="نام کاربری" :error-messages="errorMessages" :rules="[(value) => value != '' || 'نام کاربری را وارد کنید']" focused />
										</v-col>
									</v-row>
									<v-row class="mx-0 ">
										<v-col cols="4" class="px-0">
											<v-text-field label="کد امنیتی" maxLength="4" v-model="forgotCaptcha">
											</v-text-field>
										</v-col>
										<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
											<v-btn class="mr-1" color="secondary" small fab icon @click="refreshForgotCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
											<CaptchaImage ref="forgotCaptcha" :codeType="['0']" style="direction: ltr;" />
										</v-col>
									</v-row>
									<div class="form-group">
										<div v-if="forgotMessage" class="alert alert-danger" role="alert">
											{{ forgotMessage }}
										</div>
									</div>
									<v-card-actions>
										<v-spacer />
										<v-btn color="blue" dark :loading="loading" type="submit">
											دریافت کلمه عبور
										</v-btn>
										<v-spacer />
									</v-card-actions>
									<div class="text-center my-3">
										<v-btn class="mx-auto mb-2" text @click="forgotPassword = false">بازگشت به ورود</v-btn>
									</div>
								</v-form>
							</div>
						</v-slide-x-transition>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import api from '@/util/app-api'
	import CaptchaImage from '@/components/app/CaptchaImage.vue'
	import { get } from 'vuex-pathify'
	import ThemeManager from '@/util/theme-manager.js'

	export default {
		name: 'Login',
		components: {
			CaptchaImage: CaptchaImage
		},
		data() {
			return {
				loginCaptcha: '',
				forgotCaptcha: '',
				forgotPassword: false,
				forgot: { username: '' },
				user: { username: '', password: '', email: '' },
				loading: false,
				message: '',
				forgotMessage: '',
				errorMessages: '',
				show1: false,
			}
		},
		computed: {
			loggedIn() {
				return this.$store.state.auth.status.loggedIn
			},
			...get('siteConfig', [
				'longTitle', 'isCloud'
			]),
			showRegisterBtn() {
				return !this.isCloud
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			// this.$refs.submit.$el.focus()
			// this.$refs.password.$el.querySelector('input').click()
		},
		methods: {
			handleLogin() {
				if (!this.$refs.formLogin.validate()) { return }
				if (!this.$refs.loginCaptcha.verify(this.loginCaptcha)) {
					this.message = 'کد امنیتی صحیح نمی باشد.'
					return
				} else {
					this.message = ''
				}
				this.loading = true
				if (this.user.username && this.user.password) {
					this.$store.dispatch('auth/login', this.user).then((to) => {
						this.$router.push(to).catch(() => { })
					}).catch(error => {
						this.loading = false
						this.message = error.message || error.toString()
					})
				}
			},
			handleForgot() {
				if (!this.$refs.formForgot.validate()) { return }
				if (!this.$refs.forgotCaptcha.verify(this.forgotCaptcha)) {
					this.forgotMessage = 'کد امنیتی صحیح نمی باشد.'
					return
				} else {
					this.forgotMessage = ''
				}
				this.loading = true
				api.post('account/forgot/' + this.forgot.username, null, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.forgotMessage = 'کلمه عبور جدید برای شما پیامک شد.'
					})
					.catch(err => {
						this.forgotMessage = err.message
					})
					.finally(() => {
						this.loading = false
					})
			},
			refreshLoginCaptcha() {
				this.$refs.loginCaptcha.refresh()
			},
			refreshForgotCaptcha() {
				this.$refs.forgotCaptcha.refresh()
			},
			goToRegister() {
				this.$router.push({ name: 'Register', params: { customerCode: this.$route.params.customerCode || 0 } }).catch(() => { })
			}
		},

	}
</script>

<style scoped></style>
